module.exports = __webpack_public_path__ + "static/media/icon-relatorios.fcfcde7e.svg";